import { Step } from 'react-joyride';

import { LIBRARY_TOUR_CLASSES } from './classNames';

export const librarySteps: Step[] = [
  {
    target: `.${LIBRARY_TOUR_CLASSES.PAGE_HEADER}`,
    title: 'Welcome to Company Directory',
    content:
      'This is your document hub where you can access all franchise-related documents, contacts, and resources shared by your franchisor.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.MAIN_TABS}`,
    title: 'Main Navigation Tabs',
    content:
      'Switch between Documents (shared files and uploads) and Franchise Contacts (team directory and contact information).',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.DOCUMENTS_TAB}`,
    title: 'Documents Section',
    content:
      'Access all your franchise documents including shared files from your franchisor, signed documents, and your uploaded files.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.CONTACTS_TAB}`,
    title: 'Franchise Contacts',
    content:
      'Find contact information for your franchise support team, leadership, and other key personnel to help you succeed.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.DOCUMENTS_SUB_TABS}`,
    title: 'Document Categories',
    content:
      'Navigate through different document types: Shared Docs (from franchisor), Signed Docs (completed contracts), and Uploaded Docs (your files).',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.SHARED_DOCS_TAB}`,
    title: 'Shared Documents',
    content:
      'Access important documents, training materials, and resources shared by your franchisor to support your franchise journey.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.SIGNED_DOCS_TAB}`,
    title: 'Signed Documents',
    content:
      'Review all your completed and signed franchise agreements, contracts, and legal documents.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.UPLOADED_DOCS_TAB}`,
    title: 'Your Uploaded Documents',
    content:
      "Manage documents you've uploaded for your franchise application, including financial statements, permits, and other required files.",
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${LIBRARY_TOUR_CLASSES.DOCUMENTS_TABLE}`,
    title: 'Document Management',
    content:
      'View, download, and manage your documents. Each document shows its name, upload date, and actions you can perform.',
    placement: 'top',
    disableBeacon: true,
    spotlightClicks: true,
  },
];
